import { ModelCatalogueData } from "src/modules/types/model-catalogue-data";

export class GetModelCatalogueTableData {
  static readonly type = '[ModelCatalogueTableData] get save model catalogue table data';

  constructor(public payload: ModelCatalogueData[]) {
  }
}
